import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobileCatOpen, setIsMobileCatOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileOpen]);

  const mobileCategories = [
    { name: 'Scarpe', link: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
    { name: 'Felpe / Hoodie', link: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
    { name: 'T-Shirt', link: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
    { name: 'Giacche', link: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-cloudy-line' },
    { name: 'Pantaloni / Shorts', link: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
    { name: 'Cappelli', link: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-3-line' },
    { name: 'Set Completi', link: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
    { name: 'Intimo', link: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
    { name: 'Jersey', link: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
    { name: 'Accessori', link: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
    { name: 'Borse', link: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
    { name: 'Cinture', link: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
    { name: 'Profumi', link: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
    { name: 'Altro', link: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link
          to="/"
          className="font-heading text-xl md:text-2xl font-bold tracking-widest text-foreground-900 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          ITAOBUY SPREAD
        </Link>

        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-sm font-semibold text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
            Home
          </Link>
          <Link to="/#categorie" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
            Categorie
          </Link>
          <Link to="/#articoli" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
            Articoli
          </Link>
          <Link to="/#faq" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
            FAQ
          </Link>
          <Link to="/articoli/itaobuy-spreadsheet-guida-shopping" className="text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap">
            Guida all&apos;acquisto
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm font-semibold bg-primary-600 hover:bg-primary-700 text-white px-5 py-2.5 rounded-full transition-all whitespace-nowrap cursor-pointer"
          >
            Itaobuy Sheet
          </a>
        </div>

        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800 cursor-pointer"
          aria-label="Menu"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[calc(100vh-4rem)] overflow-y-auto overscroll-contain">
          <div className="flex flex-col px-4 py-4 gap-2 pb-8">
            <Link to="/" onClick={() => setIsMobileOpen(false)} className="flex items-center gap-3 text-sm font-semibold text-foreground-700 py-2 whitespace-nowrap">
              <span className="w-6 h-6 flex items-center justify-center text-primary-500"><i className="ri-home-4-line text-sm"></i></span>
              Home
            </Link>

            <button
              onClick={() => setIsMobileCatOpen(!isMobileCatOpen)}
              className="flex items-center justify-between text-sm font-semibold text-foreground-700 py-2 whitespace-nowrap cursor-pointer"
            >
              <span className="flex items-center gap-3">
                <span className="w-6 h-6 flex items-center justify-center text-primary-500"><i className="ri-grid-line text-sm"></i></span>
                Categorie Prodotti
              </span>
              <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${isMobileCatOpen ? 'rotate-180' : ''}`}>
                <i className="ri-arrow-down-s-line text-sm text-foreground-400"></i>
              </span>
            </button>

            {isMobileCatOpen && (
              <div className="ml-9 border-l-2 border-background-200/70 pl-4 py-1 space-y-1 mb-2">
                {mobileCategories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.link}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => { setIsMobileOpen(false); setIsMobileCatOpen(false); }}
                    className="flex items-center gap-2.5 text-sm text-foreground-600 py-1.5 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <span className="w-5 h-5 flex items-center justify-center text-foreground-400"><i className={`${cat.icon} text-xs`}></i></span>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <Link to="/articoli/itaobuy-spreadsheet-guida-completa" onClick={() => setIsMobileOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">
              <span className="w-6 h-6 flex items-center justify-center text-primary-500"><i className="ri-book-open-line text-sm"></i></span>
              Guida SEO
            </Link>
            <Link to="/articoli/itaobuy-spreadsheet-guida-shopping" onClick={() => setIsMobileOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">
              <span className="w-6 h-6 flex items-center justify-center text-primary-500"><i className="ri-shopping-cart-2-line text-sm"></i></span>
              Guida all&apos;acquisto
            </Link>
            <Link to="/#faq" onClick={() => setIsMobileOpen(false)} className="flex items-center gap-3 text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">
              <span className="w-6 h-6 flex items-center justify-center text-primary-500"><i className="ri-question-line text-sm"></i></span>
              FAQ
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-3 text-sm font-semibold bg-primary-600 text-white text-center px-5 py-3 rounded-full whitespace-nowrap cursor-pointer"
            >
              Itaobuy Sheet
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}